import { createContext, useContext, useState, ReactNode } from 'react'

interface MainToolbarContextModel {
    toolbarContent: ReactNode
    setToolbarContent: (content: ReactNode) => void
    clearToolbarContent: () => void
}

const MainToolbarContext = createContext<MainToolbarContextModel | undefined>(undefined)

interface ToolbarProviderProps {
    children: ReactNode;
    defaultContent?: ReactNode;
}

export const MainToolbarProvider = (props: ToolbarProviderProps) => {
    const {
        children,
        defaultContent = null 
    } = props

    const [toolbarContent, setToolbarContent] = useState<ReactNode>(defaultContent)
    const clearToolbarContent = () => setToolbarContent(defaultContent)

    const value: MainToolbarContextModel = {
        toolbarContent,
        setToolbarContent,
        clearToolbarContent
    }

    return (
        <MainToolbarContext.Provider value={value}>
            {children}
        </MainToolbarContext.Provider>
    )
}

export const useMainToolbar = (): MainToolbarContextModel => {
    const context = useContext(MainToolbarContext)

    if (!context) {
        throw new Error('useToolbar must be used within a ToolbarProvider')
    }

    return context
}